<!-- main banner  -->
<div class="collab-banner sticky-header-banner banner-sec black-text">
    <div class="container text-cenetr">
        <div class="sec-padding m-col-width mt-negative pb-0">
           
            <div class="z-index text-center">
                <div class="whats-new-label dark-banner mx-auto">
                    <img width="20" class="mr-3" src="../../../assets/icons/timesheet-page/timesheet-pre.svg">
                    <span class="primary-color paragraph-global-text sub-head-paragraph">
                        {{'groupChat.banner.preTitle' | translate}}
                    </span>
                </div>

                <h1 class="banner-heading mw-900 text-center mx-auto">{{'groupChat.banner.title' | translate}} {{'groupChat.banner.title2' | translate}}</h1>
                <p class="paragraph-global-text mw-800 mx-auto">{{'groupChat.banner.description' | translate}}</p>
               <div class="d-flex align-items-center justify-content-center my-3 mx-auto">
                    <a [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
                        <button class="save-btn">
                            {{'groupChat.banner.cta.button1' | translate}}
                        </button>
                    </a>    
                    <a [routerLink]="['en/contact-us']">
                        <button class="save-btn cfa ml-4">
                            {{'groupChat.banner.cta.button2' | translate}}
                        </button>
                    </a>                            
               </div>           
            </div>           
        </div>
    </div>
</div>


  <!-- key features sec  -->
  <div class="sec-padding">    
    <div class="container z-index">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto">{{'groupChat.what_are_groups.title' | translate}} {{'groupChat.what_are_groups.title2' | translate}}</h2>
            <p class="paragraph-global-text sub-head-paragraph mw-800">{{'groupChat.what_are_groups.description' | translate}}</p>
        </div>

        <!-- cards  -->
        <div class="row mx-0 m-col-width card-v-gap">
            <div class="col-md-4 col-sm-6 col-xs-12">
                <div class="card banner-cards justify-content-between">
                    <div>
                        <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users-round icon-primary-color"><path d="M18 21a8 8 0 0 0-16 0"/><circle cx="10" cy="8" r="5"/><path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"/></svg>
                         </div>
                         <h4 class="heading-three">{{'groupChat.what_are_groups.feature1.title' | translate}}</h4>
                         <p class="paragraph-global-text sub-head-paragraph mw-300">{{'groupChat.what_are_groups.feature1.description' | translate}}</p>
                    </div>
                </div>
             </div>
             <div class="col-md-4 col-sm-6 col-xs-12">
                 <div class="card banner-cards justify-content-between">
                      <div>
                          <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-refresh-ccw icon-primary-color"><path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/><path d="M16 16h5v5"/></svg>
                          </div>
                          <h4 class="heading-three">{{'groupChat.what_are_groups.feature2.title' | translate}}</h4>
                          <p class="paragraph-global-text sub-head-paragraph mw-300">{{'groupChat.what_are_groups.feature2.description' | translate}}</p>
                      </div>
                 </div>
              </div>
             <div class="col-md-4 col-sm-6 col-xs-12">
                 <div class="card banner-cards justify-content-between">
                     <div>
                         <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-table-2 icon-primary-color"><path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"/></svg>
                         </div>
                         <h4 class="heading-three">{{'groupChat.what_are_groups.feature3.title' | translate}}</h4>
                         <p class="paragraph-global-text sub-head-paragraph mw-300">{{'groupChat.what_are_groups.feature3.description' | translate}}</p>
                     </div>
                 </div>
             </div>             
        </div>
    </div>
</div>


<div class="sec-padding core-values-sec section_bg">
    <div class="container">
    
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto mw-800">{{"groupChat.supercharge_collaboration.title" | translate}} {{"groupChat.supercharge_collaboration.title2" | translate}} </h2>
            <p class="paragraph-global-text mw-750 sub-head-paragraph mx-auto">{{"groupChat.supercharge_collaboration.description" | translate}}</p>
        </div>

        <div class="row mx-0 m-col-width card-v-gap">
            <div class="col-md-6 col-sm-12 pl-0 m-auto">
                <figure>
                    <img class="w-100" src="../../../assets/icons/key-features/team-potential-banner.svg" alt="">
                </figure>
            </div>
           <div class="col-md-6 col-sm-12 pr-0 d-flex flex-column justify-content-center card-v-gap">
              <div class="cards-sec">
                <div class="card lft-img-card border-bottom">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lock icon-primary-color"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                    </div>
                    <div>
                        <h4 class="heading-three">{{"groupChat.supercharge_collaboration.feature1.title" | translate}}</h4>
                        <p class="paragraph-global-text">{{"groupChat.supercharge_collaboration.feature1.description" | translate}}</p>
                    </div>
                </div>
                <div class="card lft-img-card border-bottom">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search icon-primary-color"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
                    </div>
                    <div>
                        <h4 class="heading-three">{{"groupChat.supercharge_collaboration.feature2.title" | translate}}</h4>
                        <p class="paragraph-global-text">{{"groupChat.supercharge_collaboration.feature2.description" | translate}}</p>
                    </div>
                </div>
                <div class="card lft-img-card">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-globe icon-primary-color"><circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/><path d="M2 12h20"/></svg>
                    </div>
                    <div>
                        <h4 class="heading-three">{{"groupChat.supercharge_collaboration.feature3.title" | translate}}</h4>
                        <p class="paragraph-global-text">{{"groupChat.supercharge_collaboration.feature3.description" | translate}}</p>
                    </div>
                </div>
              </div>                
           </div>
        </div>
    </div>
</div>


  <!-- key features sec  -->
  <div class="sec-padding">    
    <div class="container z-index">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto">{{'groupChat.specialized_groups.title' | translate}} {{'groupChat.specialized_groups.title2' | translate}}</h2>
            <p class="paragraph-global-text sub-head-paragraph mw-800">{{'groupChat.specialized_groups.description' | translate}}</p>
        </div>

        <!-- cards  -->
        <div class="row mx-0 m-col-width card-v-gap">
            <div class="col-md-4 col-sm-6 col-xs-12">
                <div class="card banner-cards justify-content-between">
                    <div>
                        <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-user-check icon-primary-color"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><polyline points="16 11 18 13 22 9"/></svg>
                         </div>
                         <h4 class="heading-three">{{'groupChat.specialized_groups.feature1.title' | translate}}</h4>
                         <p class="paragraph-global-text sub-head-paragraph mw-300">{{'groupChat.specialized_groups.feature1.description' | translate}}</p>
                    </div>
                </div>
             </div>
             <div class="col-md-4 col-sm-6 col-xs-12">
                 <div class="card banner-cards justify-content-between">
                      <div>
                        <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-store icon-primary-color"><path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7"/><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4"/><path d="M2 7h20"/><path d="M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7"/></svg>
                          </div>
                          <h4 class="heading-three">{{'groupChat.specialized_groups.feature2.title' | translate}}</h4>
                          <p class="paragraph-global-text sub-head-paragraph mw-300">{{'groupChat.specialized_groups.feature2.description' | translate}}</p>
                      </div>
                 </div>
              </div>
             <div class="col-md-4 col-sm-6 col-xs-12">
                 <div class="card banner-cards justify-content-between">
                     <div>
                        <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-plus icon-primary-color"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M9 15h6"/><path d="M12 18v-6"/></svg>
                         </div>
                         <h4 class="heading-three">{{'groupChat.specialized_groups.feature3.title' | translate}}</h4>
                         <p class="paragraph-global-text sub-head-paragraph mw-300">{{'groupChat.specialized_groups.feature3.description' | translate}}</p>
                     </div>
                 </div>
             </div>             
        </div>
    </div>
</div>


  <!-- centered cards sec  -->
  <div class="sec-padding section_bg">    
    <div class="container z-index">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto">{{'groupChat.why_choose_amy_groups.title' | translate}} {{'groupChat.why_choose_amy_groups.title2' | translate}}</h2>
        </div>

        <!-- cards  -->
        <div class="row mx-0 m-col-width card-v-gap">
            <div class="col-md-4 col-sm-6 col-xs-12">
                <div class="card banner-cards centered-card justify-content-between">
                    <div>
                        <div class="mx-auto mb-3">
                            <img width="50" src="../../../assets/icons/collaboration-features/gree-card-tick.svg" alt="">
                         </div>
                         <h4 class="heading-three">{{'groupChat.why_choose_amy_groups.feature1.title' | translate}}</h4>
                         <p class="paragraph-global-text sub-head-paragraph mw-300">{{'groupChat.why_choose_amy_groups.feature1.description' | translate}}</p>
                    </div>
                </div>
             </div>
             <div class="col-md-4 col-sm-6 col-xs-12">
                 <div class="card banner-cards centered-card justify-content-between">
                      <div>
                        <div class="mx-auto mb-3">
                            <img width="50" src="../../../assets/icons/collaboration-features/gree-card-tick.svg" alt="">
                          </div>
                          <h4 class="heading-three">{{'groupChat.why_choose_amy_groups.feature2.title' | translate}}</h4>
                          <p class="paragraph-global-text sub-head-paragraph mw-300">{{'groupChat.why_choose_amy_groups.feature2.description' | translate}}</p>
                      </div>
                 </div>
              </div>
             <div class="col-md-4 col-sm-6 col-xs-12">
                 <div class="card banner-cards centered-card justify-content-between">
                     <div>
                        <div class="mx-auto mb-3">
                            <img width="50" src="../../../assets/icons/collaboration-features/gree-card-tick.svg" alt="">
                         </div>
                         <h4 class="heading-three">{{'groupChat.why_choose_amy_groups.feature3.title' | translate}}</h4>
                         <p class="paragraph-global-text sub-head-paragraph mw-300">{{'groupChat.why_choose_amy_groups.feature3.description' | translate}}</p>
                     </div>
                 </div>
             </div>             
        </div>
    </div>
</div>


  <!-- faqs  -->
  <div class="sec-padding mcqs-sec">
    <div class="container">
      <div class="text-center mb-5 pb-4">
        <div class="content-sec">
          <h1 class="heading-one">
            {{'groupChat.faq.title' | translate}}
            {{'groupChat.faq.title2' | translate}}
          </h1>
        </div>
      </div>
  
      <div class="accordion mw-800 mx-auto">
        <app-simple-expansion [panels]="projectProgressOptions"></app-simple-expansion>
      </div>
    </div>
  </div> 

  <div class="sec-padding cfa-sec position-relative">    
      <div class="cfa-grid"></div>
    <div class="container z-index">
        <div class="sec-title text-center">
            <h2 class="heading-one text-white mx-auto">{{'groupChat.cfa.title' | translate}} </h2>
            <p class="paragraph-global-text sub-head-paragraph mw-750 text-white">{{'groupChat.cfa.description' | translate}}</p>
  
            <div class="button-container mt-4">
                <a class="save-btn btn" [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
                    {{'groupChat.cfa.buttonTxt' | translate}}
                </a>
                <a class="save-btn cfa btn" routerLink="/en/contact-us">
                    {{'groupChat.cfa.buttonTxt2' | translate}}
                </a>
            </div>
        </div>
    </div>
  </div>
